import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = { class: "d-flex align-center" }
const _hoisted_2 = ["src"]

import i18n from '@/lang/i18n';
import type GetVehicleEvent from '@/types/responses/getVehicleEvent';
import type VehicleInstallTranslations from '@/lang/ja/vehicleInstall';

type CameraLabel = keyof typeof VehicleInstallTranslations['eventVideos']['cameraType'];

type EventVidolist = {
  field: keyof GetVehicleEvent,
  labelKey: CameraLabel
}


export default /*@__PURE__*/_defineComponent({
  __name: 'EventVideoList',
  props: {
    vehicleEvents: {},
    errorMessage: {}
  },
  setup(__props: any) {

const props = __props;

const eventVideoList: EventVidolist[] = [
  { field: 'main_video_url', labelKey: 'cameraFront' },
  { field: 'sub_video_url', labelKey: 'cameraRear' },
  { field: 'inner_video_url', labelKey: 'cameraInner' },
  { field: 'side_video_url', labelKey: 'cameraSide' }
];

function getVideoUrl(event: GetVehicleEvent, field: keyof GetVehicleEvent): string | undefined {
  const url = event[field];
  if (url == null) {
    return undefined;
  }
  return String(url);
}

function visibleVideos(event: GetVehicleEvent): EventVidolist[] {
  return eventVideoList.filter(ev => !!getVideoUrl(event, ev.field));
}

function hasNoVideos(vehicleEvent: GetVehicleEvent) {
  return eventVideoList.every(ev => !getVideoUrl(vehicleEvent, ev.field));
}

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_toolbar_title = _resolveComponent("v-toolbar-title")!
  const _component_v_toolbar = _resolveComponent("v-toolbar")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list_group = _resolveComponent("v-list-group")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, { class: "mt-4" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_toolbar, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_toolbar_title, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, null, {
                default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                  _createTextVNode("mdi-video-outline", -1)
                ]))]),
                _: 1
              }),
              _createTextVNode(" " + _toDisplayString(_unref(i18n).global.t('pages.vehicleInstall.eventVideos.title')), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_list, { class: "scrollable" }, {
        default: _withCtx(() => [
          (props.errorMessage)
            ? (_openBlock(), _createBlock(_component_v_list_item, {
                key: 0,
                title: props.errorMessage
              }, null, 8, ["title"]))
            : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(props.vehicleEvents, (vehicleEvent, index) => {
                return (_openBlock(), _createElementBlock("div", { key: index }, [
                  (hasNoVideos(vehicleEvent))
                    ? (_openBlock(), _createBlock(_component_v_list_item, {
                        key: 0,
                        title: vehicleEvent.event_date
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(i18n).global.t(`pages.vehicleInstall.eventVideos.eventType.${vehicleEvent.event_type}`)), 1)
                        ]),
                        _: 2
                      }, 1032, ["title"]))
                    : (_openBlock(), _createBlock(_component_v_list_group, { key: 1 }, {
                        activator: _withCtx(({ props }) => [
                          _createVNode(_component_v_list_item, _mergeProps({
                            title: vehicleEvent.event_date
                          }, { ref_for: true }, props), {
                            default: _withCtx(() => [
                              _createElementVNode("span", _hoisted_1, [
                                _createTextVNode(_toDisplayString(_unref(i18n).global.t(`pages.vehicleInstall.eventVideos.eventType.${vehicleEvent.event_type}`)) + " ", 1),
                                _createVNode(_component_v_icon, { class: "ml-1" }, {
                                  default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                                    _createTextVNode("mdi-video-outline", -1)
                                  ]))]),
                                  _: 1
                                })
                              ])
                            ]),
                            _: 2
                          }, 1040, ["title"])
                        ]),
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visibleVideos(vehicleEvent), (video, index) => {
                            return (_openBlock(), _createBlock(_component_v_list_item, { key: index }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_unref(i18n).global.t('pages.vehicleInstall.eventVideos.cameraType.' + video.labelKey)) + " ", 1),
                                _createElementVNode("video", {
                                  src: getVideoUrl(vehicleEvent, video.field),
                                  controls: "",
                                  class: "w-100 h-auto"
                                }, null, 8, _hoisted_2)
                              ]),
                              _: 2
                            }, 1024))
                          }), 128))
                        ]),
                        _: 2
                      }, 1024)),
                  _createVNode(_component_v_divider, { class: "my-4" })
                ]))
              }), 128))
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})